import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CoreModule } from '../core/core.module';

import { BasicLayoutRoutingModule } from './basic-layout-routing.module';
import { CommonBaseComponent } from './common-base/common-base.component';
import { HaloUnsubscribeComponent } from './halo-unsubscribe/halo-unsubscribe.component';
import { SoftwareDownloadComponent } from './software-download/software-download.component';
import { ErrorsComponent } from './errors/errors.component';
import { TncComponent } from './tnc/tnc.component';


@NgModule({
  declarations: [CommonBaseComponent, HaloUnsubscribeComponent, SoftwareDownloadComponent, ErrorsComponent, TncComponent],
  imports: [
    CommonModule,
    CoreModule,
    BasicLayoutRoutingModule
  ],
  exports: [
    CommonBaseComponent
  ]
})
export class BasicLayoutModule { }
